import { Card, Table, Input, Checkbox, Select, Typography, Button } from "antd";
import { useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";

const { Title } = Typography;
const { Option } = Select;

const dummyStudents = [
  {
    id: "STU001",
    name: "Alice Johnson",
    attendance: true,
    badge: "Gold",
    examScore: 85,
    rewards: "Star",
  },
  {
    id: "STU002",
    name: "Bob Smith",
    attendance: false,
    badge: "Silver",
    examScore: 72,
    rewards: "None",
  },
];

const ClassDetails = () => {
  const { classId } = useParams();
  const [students, setStudents] = useState([]);

  useEffect(() => {
    setStudents(dummyStudents);
  }, [classId]);

  const handleChange = (index, field, value) => {
    const updated = [...students];
    updated[index][field] = value;
    setStudents(updated);
  };

  const columns = [
    {
      title: "Student Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Attendance",
      dataIndex: "attendance",
      key: "attendance",
      render: (_, record, index) => (
        <Checkbox
          checked={record.attendance}
          onChange={(e) => handleChange(index, "attendance", e.target.checked)}
        />
      ),
    },
    {
      title: "Badge Status",
      dataIndex: "badge",
      key: "badge",
      render: (_, record, index) => (
        <Select
          value={record.badge}
          onChange={(value) => handleChange(index, "badge", value)}
          style={{ width: 100 }}
        >
          <Option value="Gold">Gold</Option>
          <Option value="Silver">Silver</Option>
          <Option value="Bronze">Bronze</Option>
        </Select>
      ),
    },
    {
      title: "Exam Score",
      dataIndex: "examScore",
      key: "examScore",
      render: (_, record, index) => (
        <Input
          type="number"
          value={record.examScore}
          onChange={(e) => handleChange(index, "examScore", e.target.value)}
          style={{ width: 80 }}
        />
      ),
    },
    {
      title: "Rewards",
      dataIndex: "rewards",
      key: "rewards",
      render: (_, record, index) => (
        <Select
          value={record.rewards}
          onChange={(value) => handleChange(index, "rewards", value)}
          style={{ width: 100 }}
        >
          <Option value="Star">Star</Option>
          <Option value="Token">Token</Option>
          <Option value="None">None</Option>
        </Select>
      ),
    },
  ];

  return (
    <>
      <Button
        type="default"
        className="mb-2"
        style={{ color: "black" }}
        onClick={() => window.history.back()}
      >
        Back
      </Button>
      <Card>
        <Title level={4}>Class Details - {classId}</Title>
        <p><strong>Date:</strong> 2025-07-16</p>
        <p><strong>Instructor:</strong> John Doe</p>

        <Table
          dataSource={students}
          columns={columns}
          rowKey="id"
          pagination={false}
        />
      </Card>
    </>
  );
};

export default ClassDetails;
